import classNames from './DeleteStudentsPopup.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';
import {
  BulkOperationResponseData,
  BulkOperationState,
} from '@/school-management/types/services/bulk';
import Button from '@/components/school-management/Button/Button';
import Download from './Download';
import AppIcon from '@/components/school-management/AppIcon/AppIcon';

interface FailureProps {
  students: StudentReportItem[];
  bulkOperation?: BulkOperationResponseData;
  onClose: () => void;
  onTryAgain: () => void;
}

const Failure = ({ students, bulkOperation, onClose, onTryAgain }: FailureProps) => {
  const { t } = useAdminTranslation();

  return (
    <>
      <AppIcon size={80} icon='error' className={classNames.icon} />
      <div>
        <div className={classNames.title} style={{ fontSize: '26px' }}>
          {t('error.weHadAProblem')}
        </div>
        <div className={classNames.description}>{t('common.tryAgainLater')}</div>
      </div>
      <Download
        students={students}
        bulkOperation={bulkOperation}
        bulkOperationState={BulkOperationState.Failed}
      />
      <div className={classNames.footer} style={{ width: '433px', flexDirection: 'column' }}>
        <Button className={classNames.button} onClick={onTryAgain}>
          {t('common.tryAgain')}
        </Button>
        <Button className={classNames.textButton} onClick={onClose}>
          {t('common.cancel')}
        </Button>
      </div>
    </>
  );
};

export default Failure;
